import React from 'react'
import styled from '@emotion/styled'
import { Slate, Ink } from 'components/Text'
import { CheckCircleIcon, Button, color, spacer, fontWeight } from 'stylist'

const QualItem = styled(Button)`
  width: 100%;
  max-width: 150px;
  white-space: normal;
  margin-bottom: ${spacer(1)};
  text-align: left;
`

const Unselected = styled(QualItem)`
  background-color: ${color('white')};
  border-color: ${color('silver')};
  ${fontWeight('regular')};

  &:hover {
    background-color: ${color('offWhite')};
  }
`

const Selected = styled(QualItem)`
  background-color: ${color('offWhite')};
  border-color: transparent;
  display: flex;
  justify-content: space-between;
`

const CheckIcon = styled(CheckCircleIcon)`
  margin: auto 0;
  min-width: 1rem;
  color: ${color('brandGreen')};
`

/**
 * Displays a list of qualifications as tiles
 * @param {Object} quals data from API of all quals in the list
 * @param {String[]} order keys in `quals` in the order to be displayed
 * @param {String} selected the key in `quals` which is currently selected
 * @param {Function} onSelect handler for when a new qualification is selected
 */
const QualList = ({ quals, order, selected, onSelect }) =>
  order.map((qualID, idx) =>
    idx === selected ? (
      <Selected type="button" key={idx}>
        <Ink>{quals[qualID].title}</Ink>
        <CheckIcon size="s" />
      </Selected>
    ) : (
      <Unselected type="button" key={idx} onClick={() => onSelect(idx)}>
        <Slate>{quals[qualID].title}</Slate>
      </Unselected>
    )
  )

export default QualList



// WEBPACK FOOTER //
// ./src/routes/estimate/subroutes/form/QualList.js